"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchExportSchema = exports.CreateBatchExportSchema = exports.BatchExportQuerySchema = exports.exportOptions = exports.BatchExportTableName = exports.BatchExportFileFormat = exports.BATCH_EXPORT_ABANDONED_AFTER_MS = exports.BATCH_EXPORT_HEARTBEAT_INTERVAL_MS = exports.BatchExportStatus = void 0;
const zod_1 = __importDefault(require("zod"));
const filters_1 = require("../../interfaces/filters");
const orderBy_1 = require("../../interfaces/orderBy");
const tableNames_1 = require("../../interfaces/tableNames");
Object.defineProperty(exports, "BatchExportTableName", { enumerable: true, get: function () { return tableNames_1.BatchTableNames; } });
const search_1 = require("../../interfaces/search");
var BatchExportStatus;
(function (BatchExportStatus) {
    BatchExportStatus["QUEUED"] = "QUEUED";
    BatchExportStatus["PROCESSING"] = "PROCESSING";
    BatchExportStatus["COMPLETED"] = "COMPLETED";
    BatchExportStatus["FAILED"] = "FAILED";
    BatchExportStatus["CANCELLED"] = "CANCELLED";
})(BatchExportStatus || (exports.BatchExportStatus = BatchExportStatus = {}));
/** Interval at which the worker refreshes a running export's updatedAt. */
exports.BATCH_EXPORT_HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;
/** Age after which an untouched QUEUED/PROCESSING export stops blocking its user's next one. */
exports.BATCH_EXPORT_ABANDONED_AFTER_MS = 3 * exports.BATCH_EXPORT_HEARTBEAT_INTERVAL_MS;
var BatchExportFileFormat;
(function (BatchExportFileFormat) {
    BatchExportFileFormat["JSON"] = "JSON";
    BatchExportFileFormat["CSV"] = "CSV";
    BatchExportFileFormat["JSONL"] = "JSONL";
})(BatchExportFileFormat || (exports.BatchExportFileFormat = BatchExportFileFormat = {}));
exports.exportOptions = {
    CSV: { label: "CSV", extension: "csv", fileType: "text/csv; charset=utf-8" },
    JSON: {
        label: "JSON",
        extension: "json",
        fileType: "application/json; charset=utf-8",
    },
    JSONL: {
        label: "JSONL",
        extension: "jsonl",
        fileType: "application/x-ndjson; charset=utf-8",
    },
};
exports.BatchExportQuerySchema = zod_1.default
    .object({
    tableName: zod_1.default.enum(tableNames_1.BatchTableNames),
    filter: filters_1.singleFilterList.nullable(),
    searchQuery: zod_1.default.string().optional(),
    searchType: zod_1.default.array(search_1.TracingSearchType).optional(),
    orderBy: orderBy_1.orderBy,
    limit: zod_1.default.number().optional(),
    page: zod_1.default.number().optional(),
    // Snapshotted at dispatch time from the user's v4 beta flag. When true, the
    // sessions export reads from the ClickHouse events table instead of the
    // legacy traces path. Persisted in the job's query column so the worker reads
    // the snapshot, never the live user record.
    useEventsTable: zod_1.default.boolean().optional(),
})
    // Reject `datasets` at runtime, not by narrowing the `tableName` enum:
    // BatchExportQueryType is shared with the batch-action read stream (which
    // handles every table), so a narrowed type breaks the worker typecheck.
    .superRefine((query, ctx) => {
    if (!(0, search_1.hasValidTracingSearchTypes)(query)) {
        ctx.addIssue({
            code: "custom",
            path: ["searchType"],
            message: search_1.TRACING_SEARCH_TYPE_REQUIRED_MESSAGE,
        });
    }
    if (query.tableName === tableNames_1.BatchTableNames.Datasets) {
        ctx.addIssue({
            code: "custom",
            path: ["tableName"],
            message: "datasets cannot be exported",
        });
    }
});
exports.CreateBatchExportSchema = zod_1.default.object({
    projectId: zod_1.default.string(),
    name: zod_1.default.string(),
    query: exports.BatchExportQuerySchema,
    format: zod_1.default.enum(BatchExportFileFormat),
});
exports.BatchExportSchema = zod_1.default.object({
    id: zod_1.default.string(),
    createdAt: zod_1.default.date(),
    updatedAt: zod_1.default.date(),
    projectId: zod_1.default.string(),
    userId: zod_1.default.string(),
    finishedAt: zod_1.default.date().nullable(),
    expiresAt: zod_1.default.date().nullable(),
    name: zod_1.default.string(),
    status: zod_1.default.enum(BatchExportStatus),
    query: exports.BatchExportQuerySchema,
    format: zod_1.default.enum(BatchExportFileFormat),
    url: zod_1.default.string().nullable(),
    log: zod_1.default.string().nullable(),
});
